<div class="bulb-resume-upload-logo-container" [ngClass]="{'bulb-upload-drop-target': !logoUrl}">
  <div *ngIf="!logoUrl">
    <aero-button [aeroStyle]="buttonStyle"
                 bulbUppyUpload
                 (uploadComplete)="onUploadComplete($event)"
                 [dragAndDropTarget]="'bulb-upload-drop-target'"
                 icon="far fa-image"
                 label="{{ 'resume.addLogo' | transloco }}">
    </aero-button>
  </div>
  <div *ngIf="logoUrl">
    <div class="bulb-resume-delete-logo">
      <img class="bulb-resume-delete-logo__image" [src]="logoUrl" [alt]="altText">
      <aero-button [aeroStyle]="buttonStyle"
        (click)="deleteLogo()"
        icon="fa-trash-alt fal"
        label="{{ 'resume.delete' | transloco }}">
      </aero-button>
    </div>
  </div>
</div>
